import { render, staticRenderFns } from "./PackageTabDetails.vue?vue&type=template&id=bfe7f9f2&scoped=true&"
import script from "./PackageTabDetails.vue?vue&type=script&lang=js&"
export * from "./PackageTabDetails.vue?vue&type=script&lang=js&"
import style0 from "./PackageTabDetails.vue?vue&type=style&index=0&id=bfe7f9f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe7f9f2",
  null
  
)

export default component.exports